import styled from "styled-components";

import Button from "ds/Button";

export const ServiceItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--section-snow-background-color, var(--snow));
  padding: 16px 32px;
  border-radius: 8px;
  min-height: 29px;
  flex-wrap: wrap;
  gap: 14px;
`;

export const Title = styled.div`
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  color: var(--header-ebony-color, var(--ebony));
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

  .config-command-toggle {
    color: var(--button-slate-color, var(--slate));
    border: none;
    border-radius: 20px;
    display: flex;
    align-items: center;
    padding: 2px 6px 3px 14px;
    height: max-content;
    outline: 1px solid
      var(--button-periwinkle-grey-border-color, var(--periwinkle-grey));
    gap: 4px;
    background-color: transparent;
    font-size: 14px;
    font-weight: 600;

    .chevron {
      transition:
        transform 0.2s linear,
        ease-in-out 1s linear;
    }

    width: max-content;
  }
`;

export const Toggle = styled(Button)`
  ${({ disabled }) =>
    disabled
      ? "color:var(--section-granite-color,var(--granite))"
      : "color:var(--section-color-primary-600-color,var(--color-primary-600))"};
`;

export const WorkerBadge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  > span {
    height: 18px;
  }
`;

export const Box = styled.div<{ width: number; height?: number }>`
  height: ${({ height = 25 }) => `${height}px`};
  width: ${({ width }) => `${width}px`};
  background-color: var(
    --section-periwinkle-grey-background-color,
    var(--periwinkle-grey)
  );
`;

export const ServiceSkeleton = styled(ServiceItem)`
  height: auto;
  .skeleton-boxes {
    display: flex;
    align-items: center;
    gap: 24px;
  }
`;

export const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  .app-skeleton {
    background-color: var(--section-snow-background-color, var(--snow));
    padding: 8px 12px;
    width: 64px;
    display: flex;
    justify-content: center;
    border-radius: 4px;
  }
`;
//
